import { all, call, put, takeLatest } from 'redux-saga/effects';
import { showErrorNotification } from '../actions';
import * as staffActions from '../actions/Staff';
import { searchStaff } from '../api/Staff';
import { SEARCH_STAFF } from '../constants/ActionTypes';

function* searchStaffByFilter({ payload }) {
  try {
    const response = yield call(searchStaff, payload.filter, payload.selectedStaffIds);
    yield put(staffActions.searchStaffSuccess(response.data.entities));
  } catch (error) {
    yield put(showErrorNotification(error.messages));
    yield put(staffActions.searchStaffFailure());
  }
}

export default function* rootSaga() {
  yield all([yield takeLatest(SEARCH_STAFF, searchStaffByFilter)]);
}
